/* eslint-disable */
/**
 * AUTO-GENERATED FILE — DO NOT EDIT.
 *
 * Generated by: scripts/generate-embedded-zustand-exports.mjs
 * Source: zustand@5.0.3 (ESM entry)
 * Generated at: 2026-01-29T20:46:28.348Z
 */

export const EMBEDDED_ZUSTAND_VERSION = "5.0.3" as const;

export const EMBEDDED_ZUSTAND_NAMED_EXPORTS = [
  "create",
  "createStore",
  "useStore"
] as const;

export const EMBEDDED_ZUSTAND_MIDDLEWARE_NAMED_EXPORTS = [
  "combine",
  "createJSONStorage",
  "devtools",
  "persist",
  "redux",
  "subscribeWithSelector"
] as const;
